<template>
  <div>
    <select @change="updateFilter" v-model="value" class="form-control">
      <option v-for="(option) in options" :value="option.value">{{ option.title }}</option>
    </select>
  </div>
</template>

<script>

export default {
  props: ['type', 'updateFilter', 'setValue'],
  data() {
    return {
      value: null,
      options: [],
    }
  },
  computed: {
    $AllCurrencies() {
      return this.$store.getters['platform/currencies']
    },
    $AllCountries() {
      return this.$store.getters['platform/countries']
    },
  },
  watch: {
    type() {
      console.log('update');
      this.updateOptions();
    },
  },
  mounted() {
    this.updateOptions();
  },
  methods: {
    updateOptions() {
      switch (+this.type) {
        case 3:
          this.options = Object.keys(this.$AllCurrencies).reduce((acc, c) => {
            acc.push({title: this.$AllCurrencies[c].currency, value: this.$AllCurrencies[c].id});
            return acc;
          }, []);
          break;
        case 4:
          let countries = this.$AllCountries.filter((c) => c.id !== 13) //в поиске не использовать
          countries = countries.map((c) => {
            return {title: c.name, value: c.id}
          });
          countries = _.orderBy(countries, 'title')

          const countryGroups = (this.$store.getters["platform/settings"]?.general ?? []).find((r) => r.option === "countryGroups");
          if (countryGroups) {
            (countryGroups.sub_value ?? []).forEach((r) => {
              countries.push({
                title: r.reduce((acc, c, i) => acc += (i !== 0 ? ', ' : '') + c.name, ''),
                value: r.map((r) => r.id)
              })
            })
          }
          countries.push({title: 'В поиске', value: 13})

          this.options = [...countries]
          // this.options = this.$AllCountries.map((c) => {
          //   return {title: c.full_country, value: c.id}
          // });
          break;
        default:
          this.options = [];
          break;
      }
      if (this.setValue) {
        this.value = this.setValue;
      } else {
        if (this.options.length) {
          this.value = this.options[0].value;
        }
      }
    }
  }
}

</script>
